import { composeIO } from 'react-compose-io'
import { ModalConfirmacaoBaixoValorView } from './ModalConfirmacaoBaixoValor.View'
import { modalConfirmacaoBaixoValorIO } from './ModalConfirmacaoBaixoValor.IO'

export const ModalConfirmacaoBaixoValor = composeIO(ModalConfirmacaoBaixoValorView, modalConfirmacaoBaixoValorIO)
